import { useLayoutEffect, useRef, useState, memo } from 'react';

/**
 * Input - if there is text overflow, a tooltip with the full text will show on hover.
 */
export const TruncatedInput = memo(({
  type = 'text',
  value = '',
  onChange,
  name,
  disabled = false,
  className = '',
  ...props
}) => {
  const inputRef = useRef(null);
  const [showTitle, setShowTitle] = useState(false);

  useLayoutEffect(() => {
    const el = inputRef.current;
    if (!el) return;

    // only show title if text is actually truncated
    setShowTitle(el.scrollWidth > el.clientWidth);
  }, [value]);

  return (
    <input
      ref={inputRef}
      type={type}
      value={value ?? ''}
      onChange={onChange}
      name={name}
      disabled={disabled}
      className={`${className} overflow-hidden text-ellipsis`}
      style={{
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
      }}
      title={showTitle ? String(value ?? '') : undefined}
      {...props}
    />
  );
});
